// extracted by mini-css-extract-plugin
export var restrictedWidthButton = "_ud-0";